import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Invoices.frontend.types'

@Injectable({ providedIn: 'root' })
export class Invoices_are_billing_contract_dates_valid_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { accountId?: number, projectId?: number, startDate: string, endDate: string, contractId: number }): Promise<{ result?: string }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.startDate)) {
      $missingRequiredInParams.push('\'startDate\'');
    }
    if (isNil($inParams.endDate)) {
      $missingRequiredInParams.push('\'endDate\'');
    }
    if (isNil($inParams.contractId)) {
      $missingRequiredInParams.push('\'contractId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

